<template>
  <div class="quota-message__item">
    <div class="quota-message__item-left-wrap">
      <slot name="left" />
    </div>
    <div class="quota-message__item-right-wrap">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentDashboardMessageItem',
};
</script>

<style lang="scss" scoped>
.quota-message {
  &__item {
    display: flex;
    width: 100%;
    padding: 0.8125rem 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
  &__item-left-wrap {
    flex-grow: 1;
    margin-right: 0.75rem;
  }
  &__item-right-wrap {
    width: 10.625rem;
    flex-shrink: 0;
    text-align: center;
    svg {
      vertical-align: middle;
      margin-right: 0.25rem;
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .quota-message {
    &__item {
      display: block;
    }
    &__item-left-wrap {
      margin-right: 0;
      margin-bottom: 0.625rem;
    }
    &__item-right-wrap {
      width: auto;
      text-align: left;
    }
  }
}
</style>
